import { render } from "./curri.vue?vue&type=template&id=d94982ac"
const script = {}

import exportComponent from "C:\\Users\\home\\Documents\\GitHub\\childu_usersite\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__